// console.debug(`${new Date().toISOString()} ${performance.now().toFixed(2)}ms [${import.meta.url}]`)
import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import { useSessionUI } from '../utils/composables/useSessionUI'
import { log } from '../utils/logger'
import { useEuriborStore } from '../valorador/market/euriborStore'
import { useIrsStore } from '../valorador/market/irsStore'
import { useSysStore } from '../valorador/stores/sysStore'
import { ROUTES } from './routeRegister'

const { isF1, isF2, isF3 } = useSessionUI()

const AppLayout = () => import('../layout/AppLayout.vue')

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // inside AppLayout /////////////////////////////////////////////
        {
            path: '/',
            component: AppLayout,
            children: [
                { ...ROUTES.home, component: () => import('../valorador/Home.vue') },
                {
                    ...ROUTES.F1,
                    component: () => import('../valorador/Home.vue'),
                    beforeEnter: () => (isF1.value = !isF1.value)
                },
                {
                    ...ROUTES.F2,
                    component: () => import('../valorador/Home.vue'),
                    beforeEnter: () => (isF2.value = !isF2.value)
                },
                {
                    ...ROUTES.F3,
                    component: () => import('../valorador/Home.vue'),
                    beforeEnter: () => (isF3.value = !isF3.value)
                },

                { ...ROUTES.compraventa, component: () => import('../valorador/Vivienda.vue') },
                // {
                //     ...ROUTES.comparador,
                //     component: () => import('../valorador/PortfolioView.vue'),
                //     beforeEnter: () => {
                //         const store = usePortfolioStore()
                //         if (store.portfolio.length === 0) {
                //             clearSession(STORAGE_KEYS.hipo)
                //             return ROUTES.valorador
                //         }
                //     }
                // },
                { ...ROUTES.comparador, component: () => import('../valorador/Comparador.vue') },

                { ...ROUTES.valorador, component: () => import('../valorador/Valorador.vue') },
                { ...ROUTES.contrato, component: () => import('../valorador/Valorador.vue') },

                { ...ROUTES.market, component: () => import('../valorador/Mercado.vue') },

                { ...ROUTES.about, component: () => import('../valorador/AboutPage.vue') },
                { ...ROUTES.experimento, component: () => import('../valorador/Experimento.vue') },

                // ************************************************************************
                // Tests ******************************************************************
                // ************************************************************************
                // test promises
                {
                    ...ROUTES.promise,
                    component: () => import('../utils/componentes/PromisePage.vue')
                },

                // test err-handling
                {
                    ...ROUTES.errHandler,
                    component: () => import('../utils/componentes/ErrorHandlerPage.vue')
                },

                // force nav-error
                {
                    ...ROUTES.navError,
                    component: () => import('../valorador/Home.vue'),
                    beforeEnter: () => {
                        throw new Error('HH: Forced Navigation Error!')
                    }
                },

                // show global errors from main.ts
                {
                    ...ROUTES.globalError,
                    component: () => import('../utils/componentes/GlobalErrorPage.vue')
                },

                {
                    ...ROUTES.fetchTest,
                    component: () => import('../utils/componentes/FetchPage.vue')
                },

                {
                    ...ROUTES.loggingTest,
                    component: () => import('../utils/componentes/LoggingPage.vue')
                }

                // {
                //     path: '/drop',
                //     name: 'drop',
                //     component: () => import('../tablador/DropPage.vue')
                // },
                // {
                //     path: '/tablador',
                //     name: 'tablador',
                //     component: () => import('../tablador/Tablador.vue')
                // }
            ]
        },

        // outside AppLayout //////////////////////////////////////////
        // catch non-existing-routes (must be at end of all routes)
        {
            path: '/:pathMatch(.*)*',
            component: () => import('../utils/componentes/NotFound.vue'),
            props: (route) => ({ route: route.path }),
            meta: { robots: 'noindex, nofollow', title: 'Página no encontrada — Veripoteca' }
        }
    ]
})

router.beforeEach(async (to) => {
    if (!to.meta.requiresMarket) return

    // Pinia
    const euriborStore = useEuriborStore()
    const irsStore = useIrsStore()

    if (irsStore.irsInitialized === undefined) {
        await irsStore.initIrsStore({ debug: false })
    }

    if (euriborStore.euriborInitialized === undefined) {
        await euriborStore.initEuriborStore({ debug: false })
    }
})

router.afterEach((to, from) => {
    const title = to.meta.title as string | undefined
    const description = to.meta.description as string | undefined
    const robots = (to.meta.robots as string | undefined) ?? 'index, follow'

    if (title) document.title = title

    const setMeta = (name: string, content: string) => {
        let tag = document.querySelector(`meta[name="${name}"]`)
        if (!tag) {
            tag = document.createElement('meta')
            tag.setAttribute('name', name)
            document.head.appendChild(tag)
        }
        tag.setAttribute('content', content)
    }

    if (description) setMeta('description', description)
    setMeta('robots', robots)

    // Canonical needs its own lookup since it's a <link>, not a <meta>
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
        canonical = document.createElement('link')
        canonical.setAttribute('rel', 'canonical')
        document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', `https://veripoteca.es${to.path === '/' ? '' : to.path}`)

    const navType = (
        performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
    )?.type

    if (
        from === START_LOCATION && // first navigation of this page load
        to.meta.openDocOnLanding &&
        window.history.state?.back == null && // no earlier in-app page
        navType === 'navigate' // not a reload or back/forward
    ) {
        useSysStore().showDoc = true
    }
})

export default router
